import React from "react";
import pdfMake from "pdfmake/build/pdfmake";
import customFonts from "./customFonts";
import {
  AccountIcon,
  AmountIcon,
  MeterNumberIcon,
  PaidIcon,
  UserIcon,
  UserRoleIcon,
} from "./card_icons";
import { generatePdf } from "./generate-pdf-content";
pdfMake.vfs = {
  ...pdfMake.vfs,
  ...customFonts,
};
pdfMake.fonts = {
  // sec: {
  //   normal: "sec-regular.ttf",
  //   bold: "sec-bold.ttf",
  // },
  sec: {
    normal: "ABC_regular.ttf",
    bold: "ABC_bold.ttf",
  },
  eng: {
    normal: "ABC_regular.ttf",
    bold: "ABC_bold.ttf",
  },
};

const icons = {
  account: AccountIcon,
  role: UserRoleIcon,
  nickname: UserIcon,
  meter: MeterNumberIcon,
  amount: AmountIcon,
  paid: PaidIcon,
};

const CardElement = ({
  data = [],
  language = "ar",
  downloadAction,
  isDownload = false,
  rawData,
  cardType
}) => {
  // icons: account / role / nickname / meter / amount / paid
  const timestamp = Date.now();
  const downloadLabel = language === "ar" ? "لتحميل تطبيق الكهرباء" : "Download App";
  const paymentLabel = language === "ar" ? "طرق الدفع" : "Payment option";

  const handleDownload = (e) => {
    e.stopPropagation();
    // let imgId = e.currentTarget.getAttribute('data-id');
    let imgId = e.currentTarget.id;
    // console.log(imgId);
    downloadAction(imgId, language);
  };

  const makePdf=(rwdt, lang, cType)=>{
    generatePdf(rwdt, lang, cType)
  }

  const isAmount =(icon)=> ["amount", "paid"].includes(icon);
  const formattedValue = (icon, value) => {
    if (!value) {
      return '-';
    }
    return isAmount(icon)
      ? language === "ar"
        ? `${value} ر.س`
        : `${value} SAR`
      : value;
  };

  return (
    <>
      <div
        className={`card-wrapper`}
        data-id={`download-${timestamp}`}
        id={`download-${timestamp}`}
        // onClick={handleDownload}
        onClick={()=>makePdf(rawData, language, cardType)}
      >
        <div className="logo"></div>
        <div className="card-row">
          {data &&
            data.length > 0 &&
            data.map(({ icon, title = "-", value = "-" }, index) => {
              const IconComponent = icons[icon];
              return (
                <div key={`cItem${index}`} className="card-item">
                  <div className="item-icon">
                    {IconComponent && (
                      <IconComponent size={15} color="#ff7300" />
                    )}
                  </div>
                  <div className="item-content">
                    <div className="item-header">{title}</div>
                    <div 
                      className={`item-value Talphanum ${isAmount(icon) && language === "ar" ? "skip" : ""}`}
                      style={{float: formattedValue(icon, value)==="-" && language==="ar"?'right':'left'}}
                    >
                      {formattedValue(icon, value)}
                    </div>                    
                  </div>
                </div>
              );
            })}
        </div>
        <div className="card-base">
          <div className="base-item qr-label">
            {downloadLabel} <div className="qr-image"></div>
          </div>
          <div className="base-item payment-label">
            {paymentLabel} <div className="pay-image"></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CardElement;
